export const autogenerateSpaceTitle = (space, t) => {
  const parts = [];

  // Add space usage type if available
  if (space.placeUsage?.name) {
    parts.push(space.placeUsage.name);
  }

  // Add city and postal code if available
  if (space.address?.city || space.address?.postal_code) {
    const locationParts = [];
    if (space.address?.city) {
      locationParts.push(space.address.city);
    }
    if (space.address?.postal_code) {
      locationParts.push(space.address.postal_code);
    }
    if (locationParts.length > 0) {
      parts.push(locationParts.join(' '));
    }
  }

  // Add capacity if available and greater than 0
  if (space.max_capacity > 0) {
    parts.push(t('spaceCard.capacityLabel', { capacity: space.max_capacity }));
  }

  // Add area if available
  if (space.area) {
    parts.push(t('spaceCard.areaLabel', { area: space.area }));
  }

  // If we have parts, join them with proper formatting
  if (parts.length > 0) {
    return parts.join(', ');
  }

  // Fallback to original name if no data available
  return space.name || t('spaceCard.unnamedSpace');
};

export default autogenerateSpaceTitle;